import styles from '../shared/common.module.css';
import React, { useEffect, useRef, useState, useReducer } from 'react';
import { useGetImgUrlByPage } from '../annotation/hooks';
import LoaderFull from '../shared/loader-full-screen';
import { AreaSelector } from '@bmunozg/react-image-area';
import { CustomRenderBox } from './customRender';


function FilePlaceholder({
	fieldsExtracted,
	setfieldsExtracted,
	tablesExtracted,
	settablesExtracted,
	totalFieldsExtracted,
	settotalFieldsExtracted,
	totalTablesExtracted,
	settotalTablesExtracted,
	PageNo,
	setPageNo,
	type,
	imgUrls,
	imgData,
	errorSelected,
	setchangeDetect,
	setchangeAdd,
	DocLockedForMe,
	tableBoxes,
	settableBoxes,
	Lables,
	setLables,
	Freez,
	setExtractUrl,
	movePage,
	setmovePage
}) {
	const [TotalPages] = useState(Object.keys(imgUrls).length);
	const [, render] = useReducer((p) => !p, false);
	const [Margin] = useState(20);

	const get_url_hook = useGetImgUrlByPage(imgUrls);
	const scrollRegister = useRef(false)

	const [cumulativeSum] = useState(() => {
		let cS = [0];
		let lst = 0;
		Object.values(imgData).map((obj) => {
			cS.push(lst + obj.image_height + Margin);
			lst += obj.image_height + Margin;
		return null
		});
		return cS;
	});

	function scrollToPageNo(scrollOffset) {
		let low = 0;
		let high = cumulativeSum.length - 1;
		while (low <= high) {
			let mid = Math.floor((low + high) / 2);
			if (cumulativeSum[mid] === scrollOffset) {
				return mid;
			} else if (cumulativeSum[mid] < scrollOffset) {
				low = mid + 1;
			} else {
				high = mid - 1;
			}
		}
		return low - 1;
	}

	const divRef = useRef(null);
	const drawClickRef = useRef({ at: 0, x: 0, y: 0 });
	const primaryPageNo = useRef(0);
	const secondaryPageNo = useRef(0);
	const refList = useRef([])


	// AreaSelector starts a new box on pointerdown of its media wrapper.
	// Stop single-clicks on the image; allow the second press of a double-click through.
	const handleImagePointerDown = (e) => {
		const DOUBLE_CLICK_MS = 500;
		const DOUBLE_CLICK_DISTANCE_PX = 16;
		const now = Date.now();
		const prev = drawClickRef.current;
		const isDoubleClick =
			now - prev.at <= DOUBLE_CLICK_MS &&
			Math.abs(e.clientX - prev.x) <= DOUBLE_CLICK_DISTANCE_PX &&
			Math.abs(e.clientY - prev.y) <= DOUBLE_CLICK_DISTANCE_PX;

		drawClickRef.current = { at: now, x: e.clientX, y: e.clientY };

		if (!isDoubleClick) {
			e.stopPropagation();
		}
	};

	useEffect(() => {
		function debounce(fn, delay) {
			let context = this;
			let setTimeoutId;

			return function () {
				if (setTimeoutId) {
					window.clearTimeout(setTimeoutId);
				}
				setTimeoutId = window.setTimeout(() => {
					fn.apply(context, arguments);
					setTimeoutId = null;
				}, delay);
			};
		}
		const handleScroll = () => {
			if (divRef.current) {
				const scrollTop = divRef.current.scrollTop;
				let pgNo = scrollToPageNo(scrollTop);
				let h1 = cumulativeSum[pgNo + 1] - scrollTop;
				let h2 = divRef.current.offsetHeight - h1;
				if (h1 > h2 || pgNo === TotalPages - 1) {
					primaryPageNo.current = pgNo;
					secondaryPageNo.current = pgNo + 1;
				} else {
					primaryPageNo.current = pgNo + 1;
					secondaryPageNo.current = pgNo;
				}
				scrollRegister.current = true
				render();
			}
		};

		// Attach the scroll event listener
		if (divRef.current) {
			divRef.current.addEventListener('scroll', debounce(handleScroll, 100));
		}
		let observerRefValue = divRef?.current;

		// Cleanup the event listener
		return () => {
			if (observerRefValue) {
				observerRefValue.removeEventListener('scroll', handleScroll);
			}
		};
	}, []);

	function SaveChanges(newP) {

		settotalFieldsExtracted((prev) => {
			let fe = JSON.parse(JSON.stringify(fieldsExtracted))
			let pgbx = { ...prev };
			pgbx[PageNo] = fe;
			return pgbx;
		});

		settotalTablesExtracted((prev) => {
			let te = JSON.parse(JSON.stringify(tablesExtracted))
			let pgbx = { ...prev };
			pgbx[PageNo] = te;
			settablesExtracted(pgbx[newP]);
			return pgbx;
		});
		// setfieldsExtracted(totalFieldsExtracted[newP]);
		// settablesExtracted(totalTablesExtracted[newP]);
		
		setPageNo(newP);
	}

	useEffect(() => {
		if (primaryPageNo.current < 0 || primaryPageNo.current >= TotalPages) {
			return;
		}
		get_url_hook.hook.mutate(primaryPageNo.current);
		get_url_hook.hook.mutate(secondaryPageNo.current);
		SaveChanges(primaryPageNo.current);
	}, [primaryPageNo.current]);

	useEffect(() => {
		if (errorSelected !== null && primaryPageNo.current !== errorSelected) {
			divRef.current.scrollTop = cumulativeSum[errorSelected];
			primaryPageNo.current = errorSelected;
			render();
		}
	}, [errorSelected]);

	function toInteger(value) {
		return isNaN(parseInt(value, 10)) ? 0 : parseInt(value, 10);
	}

	function imgLoaded(id) {
		let id2 = 'dummy_' + id;
		document.getElementById(id2).style.display = 'none';
		document.getElementById(id).style.display = 'block';
	}

	function handleError(pg) {
		get_url_hook.setimgObj((prev) => {
			return {
				...prev,
				[pg]: {
					...prev[pg],
					img_url: null,
				},
			};
		});
		
	}

	if (scrollRegister.current){
		scrollRegister.current = false 
		setchangeAdd(p=>p+1)
	}

	function diffManage(prev, area) {
		let indices = prev.map((p) => {
			return area.findIndex(
				(a) =>
					a.box_id === p.box_id &&
					(p.x !== a.x ||
						p.y !== a.y ||
						p.height !== a.height ||
						p.width !== a.width)
			);
		});
		indices.map((c) => {
			if (c !== -1) {
				if (area[c].status === 'new added') {
				} else if (
					['entity coordinate changed', 'entity changed'].includes(
						area[c].status
					)
				) {
					area[c].status = 'entity coordinate changed';
				} else {
					area[c].status = 'coordinate changed';
				}
			}
		return null
		});
		return area;
	}

	const onChangeHandler = (areas1) => {
		if (DocLockedForMe){
			setchangeDetect(true)
			setchangeAdd(p=> p+1)
		}
		settableBoxes((prev) => {
			let tp = {...prev}
			let newObj = diffManage(tp[PageNo], areas1);
			tp[PageNo] = newObj
			return tp;
		});
	};

	const customRender = (areaProps) => {
		if (!areaProps.isChanging && areaProps.height && areaProps.width) {
			return (
				<CustomRenderBox
				type={type}
				areaProps={areaProps} 
				tableBoxes={tableBoxes}
				settableBoxes={settableBoxes}
				fieldsExtracted={fieldsExtracted}
				tablesExtracted={tablesExtracted}
				refList={refList}
				Lables={Lables}
				PageNo={PageNo}
				setchangeDetect={setchangeDetect}
				setchangeAdd={setchangeAdd}
				DocLockedForMe={DocLockedForMe}
				setLables={setLables}
				/>
			);
		}
	};

	useEffect(() => {
		setExtractUrl(get_url_hook.imgObj[primaryPageNo.current]?.img_url)
	}, [get_url_hook?.imgObj[primaryPageNo.current]?.img_url])

	function movetoPage(pg) {
		let newp = pg - 1;
		divRef.current.scrollTop = cumulativeSum[newp];
		primaryPageNo.current = newp;
		render();
	}
	const firstTimeSkipmovePage = useRef(true)

	useEffect(() => {
		if (firstTimeSkipmovePage.current) { 
			firstTimeSkipmovePage.current = false
		}
		else{
			if (movePage) {
				movetoPage(movePage)
			}
			setmovePage(null)
		}
	  
	}, [movePage])
	
	



	return (
		<>
			<div className="py-3 w-full text-center flex items-center justify-center gap-4">
				<button
					disabled={!(primaryPageNo.current - 1 >= 0)}
					onClick={(e) => {
						divRef.current.scrollTop = cumulativeSum[primaryPageNo.current - 1];
						primaryPageNo.current -= 1;
						render();
					}}
					className="prevPBtn"
				></button>
				<div>
					<input
						type="number"
						placeholder="Enter row number"
						className="text-center inline-block pl-3 pr-1 py-1 border appearance-none rounded-md"
						value={primaryPageNo.current + 1}
						min={1}
						max={TotalPages}
						onChange={(e) => {
							let newp = toInteger(e.target.value) - 1;
							divRef.current.scrollTop = cumulativeSum[newp];
							primaryPageNo.current = newp;
							render();
						}}
					/>
				</div>
				<button
					disabled={!(primaryPageNo.current + 1 < TotalPages)}
					onClick={(e) => {
						divRef.current.scrollTop = cumulativeSum[primaryPageNo.current + 1];
						primaryPageNo.current += 1;
						render();
					}}
					className="nextPBtn"
				></button>
				<div>of</div>
				<div>
					<strong>{TotalPages}</strong>
				</div>
			</div>
			<div
				className={`${styles.vlFrame} grow flex flex-col justify-center overflow-auto relative`}
			>
				<div id="parent" ref={divRef} className="h-full w-full overflow-scroll">
					{Array(TotalPages)
						.fill(0)
						.map((itm, ind) => {
							return (
								<div key={`main_page_${ind}`} className='relative' 
								style={{
									
									height: imgData[ind].image_height,
									width: imgData[ind].image_width+Margin,
									margin: Margin,
								}}
								>
									
									<div
										key={`dummy_box_${ind}`} 
										id={`dummy_box_id_${ind}`}
										style={{
											height: imgData[ind].image_height,
											width: imgData[ind].image_width,
											margin: Margin
										}}
										className=" bg-gray-400 flex flex-col justify-center items-center"
									>
										<LoaderFull />
									</div>
									{(Freez || !DocLockedForMe) && <div 
									style={{
									
									height: imgData[ind].image_height,
									width: imgData[ind].image_width+Margin,
									// margin: Margin,
								}} className='absolute left-0 top-0 z-10' ></div> } 
									<div
										style={{
											display: 'none',
											height: imgData[ind].image_height,
											width: imgData[ind].image_width + Margin,
											margin: Margin,
										}}
										id={`box_id_${ind}`}
										key={`box_${ind}`}
									>
									
										{secondaryPageNo.current === PageNo - 1 &&
											secondaryPageNo.current === ind &&
											get_url_hook.imgObj[secondaryPageNo.current]?.img_url !==
												null && (
												<img
												alt='pg-1'
													src={
														get_url_hook.imgObj[secondaryPageNo.current]
															?.img_url
													}
													className="max-w-none"
												></img>
											)}
										{tableBoxes[PageNo] &&
											PageNo === ind &&
											get_url_hook.imgObj[primaryPageNo.current]?.img_url !==
												null && (
													
														
													
													
													<AreaSelector
													areas={tableBoxes[PageNo]}
													minHeight={5}
													minWidth={5}
													wrapperStyle={{}}
													globalAreaStyle={{
														border: '2px solid #47a6ff',
														backgroundColor: 'rgba(255,255,255,0.1)',
														opacity: '1',
													}}
													onChange={onChangeHandler}
													customAreaRenderer={customRender}
												>
													<div onPointerDown={handleImagePointerDown}>
													<img
													alt='pg'
														onError={() => handleError(primaryPageNo.current)}
														onLoad={() => imgLoaded(`box_id_${ind}`)}
														src={
															get_url_hook.imgObj[primaryPageNo.current]
																?.img_url
														}
														className="max-w-none"
													></img>
													</div>
												</AreaSelector>
													
												
											)}
										{secondaryPageNo.current === PageNo + 1 &&
											secondaryPageNo.current === ind &&
											get_url_hook.imgObj[secondaryPageNo.current]?.img_url !==
												null && (
												<img
												alt='pg-2'
													src={
														get_url_hook.imgObj[secondaryPageNo.current]
															?.img_url
													}
													className="max-w-none"
												></img>
											)}
									</div>
								</div>
							);
						})}
				</div>
			</div>
		</>
	);
}

export default FilePlaceholder;
